// Poza plikiem trasy, żeby kod spoza tras i testy importowały zakładkę bez ładowania drzewa tras aplikacji.
export enum FinancesTab {
  PLANNED = 'planned',
  TRANSACTIONS = 'transactions',
  IMPORTED = 'imported',
  EXPENSES = 'expenses',
}
